export default "__VITE_ASSET__Cgn66oaY__"